import Spinner from "react-bootstrap/Spinner";

const Loader = ({ className }) => {
	return (
		<div className={`flex-column ${className}`}>
			<Spinner className="text-green rotate" />
		</div>
	);
};

export default Loader;
